module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAYAAABytg0kAAAAGklEQVQImQXBAQEAAAgCIPt/SpcRpC042JYHgI4NfJCqNDgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/TASKACTV.png
// module id = 105
// module chunks = 0